import React, { useContext } from "react";
import { MobileContext } from "../../contexts/MobileContext";
import { StyledButton } from "../../styled-components/StyledButton.style";

export const ButtonOutline = ({
    outlineColor,
    backgroundColor,
    color,
    text,
    maxWidth,
    type,
}) => {
    const isMobile = useContext(MobileContext)

    return (
        <StyledButton
            type={!!type ? type : "button"}
            outlineColor={outlineColor}
            backgroundColor={backgroundColor}
            color={color}
            maxWidth={maxWidth}
            isMobile={isMobile}
        >
            {text}
        </StyledButton>
    );
};
